var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getLocale } from '../../../constants';
import { getStack } from '../stack';
export const getEntry = ({ contentType, entry, refs, locale, }) => __awaiter(void 0, void 0, void 0, function* () {
    const stack = yield getStack();
    const { cmsFormat } = typeof locale === 'string' ? getLocale(locale) : locale;
    let entryResponse = stack.ContentType(contentType).Entry(entry).language(cmsFormat);
    if (refs) {
        entryResponse = entryResponse.includeReference(refs).includeFallback();
    }
    return entryResponse.toJSON().fetch();
});
//# sourceMappingURL=getEntry.js.map